import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  reports: [],
  totalReports: 0,
  kpi: { thisMonth: 0, providerCount: 0, pastDue: 0, longestPastDueDays: 0, failed: 0 },

  clientsLoading: false,
  clientsForProvider: [],

  generationBatch: null, // { batchId, rows: [{clientId, name, status}], provider, period }

  draftLoading: false,
  draftSaving: false,
  draft: null,

  pastDueLoading: false,
  pastDue: [],

  failedLoading: false,
  failed: [],

  settingsLoading: false,
  settings: null,

  signersLoading: false,
  signers: [],
};

export const quarterlyReportSlice = createSlice({
  name: "quarterlyReport",
  initialState,
  reducers: {
    setLoading(state, action) {
      return { ...state, loading: action?.payload };
    },
    setReports(state, action) {
      return {
        ...state,
        loading: false,
        reports: action?.payload?.reports || [],
        totalReports: action?.payload?.totalReports || 0,
      };
    },
    setKpi(state, action) {
      return { ...state, kpi: action?.payload || initialState.kpi };
    },

    setClientsLoading(state, action) {
      return { ...state, clientsLoading: action?.payload };
    },
    setClientsForProvider(state, action) {
      return { ...state, clientsLoading: false, clientsForProvider: action?.payload || [] };
    },

    setGenerationBatch(state, action) {
      return { ...state, generationBatch: action?.payload };
    },
    clearGenerationBatch(state) {
      return { ...state, generationBatch: null };
    },

    setDraftLoading(state, action) {
      return { ...state, draftLoading: action?.payload };
    },
    setDraftSaving(state, action) {
      return { ...state, draftSaving: action?.payload };
    },
    setDraft(state, action) {
      return { ...state, draftLoading: false, draftSaving: false, draft: action?.payload };
    },
    clearDraft(state) {
      return { ...state, draft: null };
    },

    setPastDueLoading(state, action) {
      return { ...state, pastDueLoading: action?.payload };
    },
    setPastDue(state, action) {
      return { ...state, pastDueLoading: false, pastDue: action?.payload || [] };
    },

    setFailedLoading(state, action) {
      return { ...state, failedLoading: action?.payload };
    },
    setFailed(state, action) {
      return { ...state, failedLoading: false, failed: action?.payload || [] };
    },

    setSettingsLoading(state, action) {
      return { ...state, settingsLoading: action?.payload };
    },
    setSettings(state, action) {
      return { ...state, settingsLoading: false, settings: action?.payload };
    },

    setSignersLoading(state, action) {
      return { ...state, signersLoading: action?.payload };
    },
    setSigners(state, action) {
      return { ...state, signersLoading: false, signers: action?.payload || [] };
    },

    reset() {
      return initialState;
    },
  },
});

export const {
  setLoading,
  setReports,
  setKpi,
  setClientsLoading,
  setClientsForProvider,
  setGenerationBatch,
  clearGenerationBatch,
  setDraftLoading,
  setDraftSaving,
  setDraft,
  clearDraft,
  setPastDueLoading,
  setPastDue,
  setFailedLoading,
  setFailed,
  setSettingsLoading,
  setSettings,
  setSignersLoading,
  setSigners,
  reset,
} = quarterlyReportSlice.actions;

export default quarterlyReportSlice.reducer;
